import { concat, without } from 'lodash';
import { createReducer } from '@mews/framework';
import { MESSAGE_CENTER_OPENED, MESSAGE_CENTER_CLOSED } from '../actionTypes';

export const loadingIds =
    (actionType: $TSFixMe) =>
    (state = [], action: $TSFixMe) => {
        switch (action.type) {
            case `${actionType}_STARTED`:
                return concat(state, [action.meta.id]);
            case `${actionType}_FAILED`:
            case `${actionType}_SUCCEEDED`:
                return without(state, action.meta.id);
            default:
                return state;
        }
    };

export const messageCenter = createReducer(
    {},
    {
        [MESSAGE_CENTER_OPENED]: (state: $TSFixMe) => ({
            ...state,
            visible: true,
        }),
        [MESSAGE_CENTER_CLOSED]: (state: $TSFixMe) => ({
            ...state,
            visible: false,
        }),
    }
);
